import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CustomTooltipDirective } from '@core-utils';

@Component({
  selector: 'ui-badge',
  imports: [CustomTooltipDirective],
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
  severity = input<string>('info');
  text = input<string | number>('');
  class = input<string>('');
  tooltip = input<string>('');
}
